import { useFrontendConfigContext as F } from "../../config-lib/contexts/FrontendConfigContext.js";
import "../../config-lib/deserializes/yup/config.js";
import "../../config-lib/graphql/getFrontendConfig.js";
import "@apollo/client";
import "../../apostle-lib/deserializes/yup/apostle.js";
import { useMemo as M, useCallback as c, useEffect as j } from "react";
import * as o from "ramda";
import "../../temp-lib/util/i18n/helper/locale.js";
import "react-i18next";
import { CurrencyTokenType as g, CurrencyMoneyType as f, EMPTY_CURRENCY as y, WETH_REFRESH_CURRENCY_RATE_DURATION as B } from "../constants/currency.js";
import H from "../hooks/graphql/useGetCurrencyInfo.js";
import K from "../hooks/graphql/useGetTokenPriceToUSD.js";
import { ChainAddressType as l } from "../../temp-lib/constants/chain.js";
import { RETRY as $ } from "../../temp-lib/constants/retry.js";
import q from "../../temp-lib/hooks/web3/useWeb3.js";
import { createStrictContext as Q } from "../../temp-lib/util/context/createStrictContext.js";
import { formatNumberString as R, DETAIL_USD_OPTIONS as z } from "../../temp-lib/util/misc/formatNumberString.js";
import J from "p-retry";
import V from "use-async-effect";
import { erc20Abi as O } from "viem";
import { jsx as X } from "react/jsx-runtime";
const [Z, yt] = Q("Currency"), Rt = (S) => {
  const {
    enabled: m = !1,
    children: I
  } = S, {
    config: A,
    waitConfig: P
  } = F(), {
    fromWei: p
  } = q(), {
    data: d,
    fetch: _
  } = H(), {
    data: C,
    fetch: T
  } = K(), U = M(() => {
    if (o.isNotNil(C)) {
      const t = (s) => {
        const u = o.find(o.propEq(s, "type"), C);
        return o.propOr(0, "ratio", u);
      }, r = Object.values(g), e = Object.values(f);
      let n = {};
      return o.forEach((s) => {
        let u = {};
        o.forEach((E) => {
          u = o.assoc(E, t(s), u);
        }, e), n = o.assoc(s, u, n);
      }, r), n;
    }
    return {};
  }, [C]), h = c((t) => {
    const r = o.values(d || {});
    return o.find((e) => (e == null ? void 0 : e.assetName) === t, r);
  }, [d]), i = c((t) => o.propOr(null, t || "", d), [d]), b = c((t) => {
    const r = i(t), e = {
      address: {
        [l.POLYGON]: (r == null ? void 0 : r.address) || "0x0",
        [l.RONIN]: (r == null ? void 0 : r.address) || "0x0"
      },
      abi: {
        [l.POLYGON]: O,
        [l.RONIN]: O
      },
      method: ""
    };
    return {
      GET_USER_BALANCE: {
        ...e,
        method: "balanceOf"
      },
      GET_USER_ALLOWANCE: {
        ...e,
        method: "allowance"
      },
      REQUEST_ALLOWANCE: {
        ...e,
        method: "approve"
      }
    };
  }, [i]), v = c((t) => {
    const r = i(t);
    return (r == null ? void 0 : r.address) || "0x0";
  }, [i]), N = c((t, r, e = {}) => {
    if (o.isNil(r))
      return y;
    const n = i(t);
    if (o.isNotNil(t) && o.isNil(n))
      return y;
    const s = p(String(r), (n == null ? void 0 : n.decimals) || 0);
    return R(s, e);
  }, [p, i]), L = c((t, r = 18) => o.isNil(t) ? y : t === 0 ? "0" : R(String(t), {
    maxLength: 10,
    maxDecimal: r,
    minNumberWithoutENotation: 5e-11,
    allowENotation: !0,
    allowedLargeNumberAbbr: !1,
    priorities: ["maxLength", "maxDecimal"]
  }), []), D = c((t, r, e = {}) => {
    const n = N(t, r, e), s = i(t);
    return o.isNotNil(s) ? `${n} ${s.name}` : n;
  }, [N, i]), a = c((t = g.Weth, r = f.Usd) => o.pathOr(0, [t, r], U), [U]), W = c((t, r, e, n = {}) => {
    const s = i(t);
    if (o.isNil(s))
      return "0";
    const u = a(t || g.Weth, f.Usd), E = e ? p(String(r), s.decimals) : String(r), Y = u * parseFloat(E);
    return R(Y.toString(), {
      ...z,
      ...n
    });
  }, [p, i, a]), k = c((t, r, e) => {
    if (r === e)
      return t;
    const n = a(r, f.Usd), s = a(e, f.Usd);
    return s === 0 ? 0 : t * n / s;
  }, [a]), w = c((t, r) => {
    const e = a(r, f.Usd);
    return t * e;
  }, [a]), x = c((t) => {
    const r = o.pathOr([], ["supportToken", t], A);
    return o.is(Array, r) ? o.map((e) => h(e), r) : [];
  }, [A, h]), G = c((t) => o.head(x(t)), [x]);
  return j(() => {
    if (m) {
      T();
      const t = setInterval(T, B);
      return () => clearInterval(t);
    }
  }, [m]), V(async (t) => {
    if (m) {
      const r = await P();
      if (t()) {
        const e = (r == null ? void 0 : r.supportToken.allTokens) || {
          onChain: [],
          offChain: []
        }, n = o.concat(e.offChain, [...e.onChain, "Item_ronin_erc20_0203"]);
        await J(async () => {
          if (t() && o.isNil(await _(n)))
            throw new Error("currency info is not loaded yet");
        }, $.DEFAULT).catch(() => {
        });
      }
    }
  }, [m]), /* @__PURE__ */ X(Z, {
    value: {
      getApeironPrice: N,
      getApeironDetailPrice: L,
      getApeironPriceWithUnit: D,
      getCurrencyByAssetName: h,
      getCurrency: i,
      getCurrencyAddress: v,
      getCurrencyContract: b,
      getExchangeRate: a,
      getUSDPrice: W,
      getDefaultSupportCurrency: G,
      convertCurrencyPrice: k,
      convertCurrencyToUsd: w
    },
    children: I
  });
};
export {
  Rt as CurrencyProvider,
  yt as useCurrencyContext
};
//# sourceMappingURL=CurrencyContext.js.map
